import PropTypes from 'prop-types';

import Colors from '../utils/colors';

const themes = {
  base: Colors.dark,
  secondary: Colors.interaction,
  light: 'white',
  dark: Colors.medium
};

const HouseMagnifyingGlassIcon = ({ theme = 'base' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
  >
    <g fill="none" fillRule="evenodd" stroke={themes[theme]} strokeWidth="1.5">
      <g transform="translate(1 1)">
        <path strokeLinecap="round" d="M26.639 26.639l10.808 10.808" />
        <circle cx="15.629" cy="15.629" r="15.629" />
      </g>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M22.626 13.779v10.813H10.83V13.779"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.88 16.236l8.848-8.847 8.847 8.847"
      />
    </g>
  </svg>
);

HouseMagnifyingGlassIcon.propTypes = {
  theme: PropTypes.oneOf(Object.keys(themes))
};

export default HouseMagnifyingGlassIcon;
